import Content from '../../content.js';

namespace('IO.Views.NodeGroupRoles', function (exports) {
  'use strict';
  var Show = Content.extend({
    dom: {
      DELETE_BUTTON: '.pjax-delete',
    },

    events: function () {
      var events = {};

      events['click ' + this.dom.DELETE_BUTTON] = '_warnImpactedNodeGroups';
      return events;
    },

    _warnImpactedNodeGroups: function (e) {
      var url = location.href.match(/\d+$/),
        warnModal;

      if (!$(e.target).hasClass('triggered')) {
        e.preventDefault();

        warnModal = new IO.Views.Components.ConfirmationDialog({
          url:
            '/' +
            currentCustomer +
            '/node_group_roles/' +
            url +
            '/impacted_node_groups',
          template: 'node_group_roles/impacted_node_groups',
          method: 'GET',
          width: 800,
        });

        warnModal.impact().answer(function (proceed) {
          if (proceed) {
            $(e.target).addClass('triggered').trigger('click');
          }
          warnModal.destroy();
        });
        return false;
      }
    },
  });

  exports.Show = Show;
});
